const breakpoints = () => ({
  values: {
    xs: 0,
    hs: 320,
    sm: 600,
    nm: 768,
    md: 900,
    lg: 1200,
    xl: 1536,
  },
});

export default breakpoints;
